<script setup>
import { onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/state/pinia/auth';
const authStore = useAuthStore();
const router = useRouter();

onMounted(() => {
  authStore.checkSession();
});

let initialized = false;

watch(
    () => authStore.activeWorkspace,
    (newVal, oldVal) => {
      if (!initialized) {
        initialized = true;
        return;
      }

      if (newVal && newVal !== oldVal) {
        router.push('/');
      }
    }
);
</script>

<template>
  <router-view :key="$route.fullPath" />
</template>

<style>
/* Global Multiselect styles - smaller font size */
.multiselect {
  min-height: 38px !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 12px !important;
  border-radius: 0.25rem !important;
}

.multiselect-wrapper {
  min-height: 38px !important;
  padding: 0 !important;
  font-size: 12px !important;
  border-radius: 0.25rem !important;
}

.multiselect-input-wrapper,
.multiselect-single-label-wrapper {
  min-height: 34px !important;
  padding: 5px 12px !important;
  margin: 0 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  border: none !important;
  background: transparent !important;
}

.multiselect-placeholder {
  min-height: 34px !important;
  padding: 5px 12px !important;
  margin: 0 !important;
  font-size: 12px !important;
  line-height: 20px !important;
  border: none !important;
  background: transparent !important;
}

.multiselect .multiselect__single,
.multiselect .multiselect__input {
  font-size: 14px !important;
  line-height: 24px !important;
  padding: 0 !important;
}

.multiselect .multiselect__placeholder {
  font-size: 14px !important;
  color: #999 !important;
}

.multiselect-single-label {
  font-size: 14px !important;
  line-height: 24px !important;
}

.multiselect-option {
  font-size: 14px !important;
  padding: 8px 12px !important;
}

/* Selected option - info color */
.multiselect-option.is-selected {
  background-color: #50a5f1 !important;
  color: #fff !important;
}

/* Selected option with pointer/hover - darker info color */
.multiselect-option.is-selected.is-pointed {
  background-color: #3b8dd6 !important;
  color: #fff !important;
}

/* Selected option hover - darker info color */
.multiselect-option.is-selected:hover {
  background-color: #3b8dd6 !important;
  color: #fff !important;
}

/* Unselected option hover */
.multiselect-option.is-pointed {
  background-color: #f8f9fa !important;
}

.multiselect-option:hover {
  background-color: #f8f9fa !important;
}

.multiselect,
.multiselect-wrapper {
  box-shadow: none !important;
}

.multiselect-search {
  /* Stay inside the box (default top/bottom:0). A fixed 35px height + 1px
     margin made the white search bg overflow 2px and paint over the bottom
     border — which is why every dropdown looked open-bottomed. */
  height: 100% !important;
  margin-top: 0 !important;
}

/* Pewny odstęp między kafelkami w rzędzie (niezależny od bootstrapowych
   gutterów, które w tym buildzie potrafią się gubić). */
.g-tiles {
  margin-left: -0.6rem;
  margin-right: -0.6rem;
  margin-bottom: 1.5rem; /* odstęp między osobnymi rzędami paneli */
  row-gap: 1.5rem;       /* odstęp pionowy gdy karty się zawijają w jednym rzędzie */
}
.g-tiles > [class*="col-"] {
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}
</style>
